import React from 'react';
import Section from './Section';
import { TESTIMONIALS } from '../constants';
import { Instagram } from 'lucide-react';

const Proof: React.FC = () => {
  return (
    <Section id="proof" className="bg-black border-t border-white/10">
      
      {/* Editorial Header */}
      <div className="flex flex-col md:flex-row justify-between items-end mb-16 md:mb-24 gap-6">
        <h2 className="text-4xl md:text-5xl font-display text-white leading-tight">
          SELECTED<br/>WORKS
        </h2>
        {/* Instagram Link - Made prominent on Mobile */}
        <a 
          href="https://instagram.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-500 hover:text-white transition-colors border border-white/10 hover:border-white/30 px-4 py-2 rounded-full md:border-0 md:p-0 md:rounded-none md:border-b md:border-transparent md:hover:border-white md:pb-1"
        >
          <Instagram size={14} className="md:hidden" />
          Volg ons op Instagram
        </a>
      </div>

      {/* Asymmetrical Grid */}
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-24 md:mb-32">
        <div className="md:col-span-8 relative group cursor-crosshair overflow-hidden aspect-[4/3] md:aspect-auto h-auto md:h-[600px]">
           <img 
            src="https://images.unsplash.com/photo-1601362840469-51e4d8d58785?q=80&w=2070&auto=format&fit=crop" 
            alt="Lamborghini Huracan" 
            className="w-full h-full object-cover transition-all duration-1000 group-hover:scale-105 opacity-100 md:opacity-80 md:group-hover:opacity-100"
           />
           <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end bg-gradient-to-t from-black/80 via-transparent to-transparent md:bg-none">
             {/* Mobile: Always visible. Desktop: Reveal on Hover */}
             <div className="transform translate-y-0 opacity-100 md:translate-y-4 md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100 transition-all duration-500">
               <h3 className="text-2xl md:text-3xl font-display text-white">LAMBORGHINI HURACÁN</h3>
               <p className="text-neutral-300 md:text-neutral-400 text-sm mt-2">Full Body Stealth PPF</p>
             </div>
           </div>
        </div>
        
        <div className="md:col-span-4 flex flex-col gap-6">
          <div className="relative group cursor-crosshair overflow-hidden h-[300px] md:h-full">
            <img 
              src="https://images.unsplash.com/photo-1494905998402-395d579af36f?q=80&w=2073&auto=format&fit=crop" 
              alt="Detailing Close up" 
              className="w-full h-full object-cover transition-all duration-1000 group-hover:scale-105 opacity-100 md:opacity-80 md:group-hover:opacity-100"
            />
            <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end bg-gradient-to-t from-black/80 via-transparent to-transparent md:bg-none">
              <div className="transform translate-y-0 opacity-100 md:translate-y-4 md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100 transition-all duration-500">
                <h3 className="text-lg md:text-xl font-display text-white">FERRARI 488</h3>
                <p className="text-neutral-300 md:text-neutral-400 text-xs mt-1">Correction & Coating</p>
              </div>
            </div>
          </div>
           <div className="bg-neutral-900/30 border border-white/5 p-8 flex items-center justify-center h-[150px] md:h-[200px]">
             <div className="text-center">
               <span className="block text-3xl md:text-4xl font-display text-white mb-2">10+</span>
               <span className="text-neutral-500 text-xs uppercase tracking-widest">Jaar Ervaring</span>
             </div>
          </div>
        </div>
      </div>

      {/* Testimonials - Minimal */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-24">
        {TESTIMONIALS.map((t) => (
          <div key={t.id} className="flex flex-col">
            <p className="text-neutral-300 text-base md:text-lg leading-relaxed mb-6 md:mb-8 font-light">"{t.text}"</p>
            <div className="mt-auto">
              <div className="h-px w-8 bg-white/20 mb-4"></div>
              <div className="text-white font-display text-sm tracking-wider">{t.name}</div>
              <div className="text-neutral-600 text-xs uppercase mt-1">{t.car}</div>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};

export default Proof;